var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-splash"},[_c('div',{staticClass:"loader-container"},[_c('p',{staticClass:"loading-data-text"},[_vm._v(_vm._s(_vm.text))]),_c(_setup.MaterialIcon,{staticClass:"spinner",attrs:{"icon":"autorenew"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }